import { createSlice } from "@reduxjs/toolkit";

export const userTourSlice = createSlice({
  name: "UserTour",
  initialState: {
   welcome_page:false,
   main_dashboard:false,
   settings_page:false,
   programs_page:false,
   campaigns_page:false,
    integration_page:false,
    members_page:false,
    add_member_page:false
  },
  reducers: {
    UPDATE_USER_TOUR: (state,action) => {

      return { ...state, ...action?.payload };
    },
    CLEAR_USER_TOUR: (state) => {
      return {  welcome_page:false,
   main_dashboard:false,
   settings_page:false,
   programs_page:false,
   campaigns_page:false,
   integration_page:false,
   members_page:false,
   add_member_page:false
  };
    },
  },
});

export const { UPDATE_USER_TOUR ,CLEAR_USER_TOUR} = userTourSlice.actions;

export default userTourSlice.reducer;
